import React from 'react';
import { useAtomValue } from 'jotai';
import { sessionAtom } from '../../jotai/atoms/session';
import { UserForm } from '../User/UserForm';
import { Done } from '../Finish/Done';
import { Error } from '../Error';
import { Quiz } from '../Kreeda/Quiz/Quiz';
import { Crossword } from '../Kreeda/Crossword/Crossword';
const Main = ({ code, kreeda, onSubmit }) => {
    const session = useAtomValue(sessionAtom);
    let Component, props;
    switch (kreeda.kreedaType) {
        case 'Quiz':
            Component = Quiz;
            props = {
                code,
                duration: kreeda.kreedaData.duration,
                questions: kreeda.kreedaData.questions,
                onSubmit,
            };
            break;
        case 'Crossword':
            Component = Crossword;
            props = {
                code,
                data: kreeda.kreedaData,
                onSubmit,
            };
            // Component = Main;
            // props = { code, kreeda, onSubmit };
            break;
        default:
            Component = Error;
            props = { message: 'Unknown Kreeda. Please contact Host or Admin' };
    }
    return (React.createElement(React.Fragment, null, session.submitted ? (React.createElement(Done, null)) : session.user ? (React.createElement(Component, { ...props })) : (React.createElement(UserForm, null))));
};
export { Main };
